import React, { FunctionComponent } from 'react';
import WithDataRecord from 'hoc/WithDataRecord';
import {
  AdminApi,
  AdminInvestmentList,
  AdminInvestmentsListOrderingEnum,
  InvestmentAcquisitionTypeRecipientEnum,
} from 'api';
import useGoTo from 'hooks/use-go-to';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import StudioConnectedInvestmentsTable from 'src/apps/issuer/pages/voucher-details/connected-investments/StudioConnectedInvestmentsTable';

interface ReferralInvestmentsTableProps {
  voucherId: string;
  forceDataLoad?: boolean;
  defaultLimit?: number;
}

const ReferralInvestmentsTable: FunctionComponent<ReferralInvestmentsTableProps> = WithDataRecord<
  AdminApi,
  AdminInvestmentList
>(AdminApi)(
  ({ data, ordering, onOrderBy, loading, paginationProps, voucherId }) => {
    const goTo = useGoTo(ISSUER_ROUTES.investmentDetails);

    return (
      <>
        <StudioConnectedInvestmentsTable
          voucherId={voucherId}
          loading={loading}
          onOrderBy={onOrderBy}
          ordering={ordering}
          goToDetails={(productId: string, investmentId: string) => goTo({ productId, investmentId })}
          investments={(data || []).map((investment) => ({
            ...investment,
            acquisitionType: investment.acquisitionType || InvestmentAcquisitionTypeRecipientEnum.ISSUANCE,
          }))}
          paginationProps={paginationProps}
        />
      </>
    );
  },
  (api, props, offset, limit, ordering) => {
    return api.adminInvestmentsList({
      offset,
      limit,
      ordering: ordering as AdminInvestmentsListOrderingEnum,
      ...props,
      voucherId: [props.voucherId],
    });
  },
);

export default ReferralInvestmentsTable;
